
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 13 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0v16.5h12.692V0H0zm1.27 1.27h10.153v13.96H1.27V1.27zm1.903 1.903v1.27h3.808v-1.27H3.173zm0 3.808V8.25H9.52V6.98H3.173zm0 2.538v1.27H9.52v-1.27H3.173zm0 2.539v1.269h3.808v-1.27H3.173z"}})])
          )
        }
      }
    